import type { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleSwitcher } from '../components/LocaleSwitcher';
import { common } from '../i18n/messages';
import { BrandMark } from './icons';

/** Centred single-card layout for the flows outside the shell: sign-in, refusal, loading. */
export function FullPage({ children, switcher = true }: { children: ReactNode; switcher?: boolean }) {
  const intl = useIntl();
  return (
    <main className="page-center">
      <div className="stack" style={{ width: '100%', maxWidth: 420 }}>
        <a className="lockup" href="/" aria-label={intl.formatMessage(common.home)}>
          <BrandMark className="mark" />
          <span>
            <b>
              <FormattedMessage {...common.brand} />
            </b>
            <span>
              <FormattedMessage {...common.product} />
            </span>
          </span>
        </a>
        {children}
        {switcher && (
          <div className="row end">
            <LocaleSwitcher signedIn={false} compact />
          </div>
        )}
      </div>
    </main>
  );
}
